import { connect } from 'react-redux';
import IntercomChat from 'common/components/intercom_chat';

const mapStateToProps = ({ user }) => {
  return {
    shouldShow: !user.logged_in || user.profile_data.is_client,
    user: user.profile_data
  };
}

export default connect(mapStateToProps)(IntercomChat);



// WEBPACK FOOTER //
// ./common/containers/intercom_chat.js